module.exports = __webpack_public_path__ + "img/1S.f252768e.png";